import React, { ReactNode } from 'react';
// CSSはインポートした順に生成され、後にインポートしたCSSの方が優先されるので、
// まず他のコンポーネントや共通CSSをインポートして、その後でコンポーネントごとのCSSをインストールすること
// つまり、styles.module.cssのインポートはインポート文の複数行のうちの最後に置いておくのが安全
import styles from './styles.module.css';

export type TextlabelProps = {
    className?: string,
    children?: ReactNode,
} & JSX.IntrinsicElements['label']


const Textlabel : React.FC<TextlabelProps> = ({
    className = '',
    children,
    ...props
}) => {
    // class属性を設定
    let classString = styles.textlabel;
    if (className) {
        classString = [classString, className].join(' ');
    }

    return (
        <label 
            className={classString}
            { ...props }
        >
        {children}
        </label>
    );
};

export default Textlabel;
